import { render, staticRenderFns } from "./TipBondAndNominator.vue?vue&type=template&id=320b1bb9&"
import script from "./TipBondAndNominator.vue?vue&type=script&lang=js&"
export * from "./TipBondAndNominator.vue?vue&type=script&lang=js&"
import style0 from "./TipBondAndNominator.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports